const defaultWeightMap = {
    Bold: 700,
    NarrowBold: 600,
    SemiBold: 500,
    Medium: 500,
    News: 450,
    Regular: 400,
};
const weightMap = {
    'TheSans C4s': defaultWeightMap,
    Verdana: defaultWeightMap,
    ClanOT: Object.assign(Object.assign({}, defaultWeightMap), { Medium: 600 }),
    'Clan Pro': Object.assign(Object.assign({}, defaultWeightMap), { Medium: 600 }),
    'Bernina Sans': Object.assign(Object.assign({}, defaultWeightMap), { SemiBold: 600 }),
    'Apple SD Gothic Neo': defaultWeightMap,
    Calibri: defaultWeightMap,
    Roboto: defaultWeightMap,
    Arial: defaultWeightMap,
    Verveine: defaultWeightMap,
};
/**
 * Converts a string based font weight to a number based font weight.
 */
export const weightToNumber = (weight, fontFamily) => {
    const weightWithoutItalic = weight.replace('Italic', '').trim();
    return weightMap[fontFamily || 'Verdana'][weightWithoutItalic];
};
